export default __webpack_public_path__ + "static/media/planticon_7.093fa78e.png";